import { Injectable } from '@angular/core';


import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '../pages/components/confirmation-modal/confirmation-modal.component';
import { BehaviorSubject, Observable } from 'rxjs';



@Injectable({
  providedIn: 'root',
})
export class ConfirmationModalService {
  ngbModalOptions: NgbModalOptions;
  ngbFbModalOptions: NgbModalOptions;
    private passEvent$: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(private ngbModal: NgbModal) {
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      windowClass: 'custom-modal',
    };
    this.ngbFbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      windowClass: 'fcustom-modal',
    };
  }

  open(title: string, message: string) {
    const modalRef = this.ngbModal.open(
      ConfirmationModalComponent,
      this.ngbModalOptions
    );
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
  }
  openPopUp(title: string, message: string,submessage:string) {
    const modalRef = this.ngbModal.open(
      ConfirmationModalComponent,
      this.ngbModalOptions
    );
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.submessage = submessage
  }

  modalwithbuttons(
    title: string,
    message: string,
    submessage: string,
    action: any
  ) {
    const modalRef = this.ngbModal.open(
      ConfirmationModalComponent,
      this.ngbModalOptions
    );
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.submessage = submessage;
    modalRef.componentInstance.action = action;
  }

  modalwithManualLegibuttons(
    title: string,
    message: string,
    submessage: string,
    submessage2: string,
    submessage3: string,
    action: any
  ) {
    const modalRef = this.ngbModal.open(
      ConfirmationModalComponent,
      this.ngbModalOptions
    );
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.submessage = submessage;
    modalRef.componentInstance.submessage2 = submessage2;
    modalRef.componentInstance.submessage3 = submessage3;
    modalRef.componentInstance.action = action;
  }

  openWithAge(title: string, message: string) {
    const modalRef = this.ngbModal.open(
      ConfirmationModalComponent,
      this.ngbModalOptions
    );
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
  }

  modalwithAgeCheckbuttons(
    title: string,
    message: string,
    submessage: string,
    action: any
  ) {
    const modalRef = this.ngbModal.open(
      ConfirmationModalComponent,
      this.ngbModalOptions
    );
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.submessage = submessage;
    modalRef.componentInstance.action = action;
  }


  modalwithSwitchProduct(title: string,
    message: string,
    submessage: string,
    action: any) {
    const modalRef = this.ngbModal.open(
      ConfirmationModalComponent,
      this.ngbModalOptions
    );
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.submessage = submessage;
    modalRef.componentInstance.action = action;
  }


  openGenericBackendError() {
    this.open(
      'Fehler',
      'Bitte warten Sie ein paar Minuten und versuchen Sie es erneut.'
    );
  }

  openProductExistsError() {
    this.modalwithbuttons(
      'Bereits ein Safe&Cool vorhanden',
      'Der Kunde hat bereits ein aktives Safe&Cool Konto. Die Eröffnung eines zweiten Safe&Cool ist leider nicht möglich.',
      '',
      'alreadyExists'
    );
  }

  openOtherProductExistsError() {
    this.modalwithbuttons(
      'Bereits Konto vorhanden',
      'Der Kunde hat bereits ein aktives Konto. Die Eröffnung eines zweiten  ist leider nicht möglich.',
      '',
      'alreadyExists'
    );
  }

  openExistingApplicationError(){
    this.modalwithbuttons(
      'Sie sind bereits BAWAG Kunde',
      'Bitte melden Sie sich mit Ihren persönlichen eBanking Zugangsdaten (Verfügernummer und PIN) an, um den Kontoantrag zu starten.',
      '',
      'alreadyExists'
    )
  }
  openMissingRequiredProductError() {
    this.modalwithbuttons(
      'Sie haben kein BAWAG Girokonto',
      'Für die gewünschte SparBox Flex b4-19 wird ein b4 - 19 Girokonto als Referenzkonto benötigt.Bitte eröffnen Sie zunächst ein Girokonto und fahren Sie dann mit diesem Produkt fort.',
      '',
      'alreadyExists'
    )
  }

  openMissingRequiredProductErrorForFix() {
    this.modalwithbuttons(
      'Sie haben keine BAWAG SparBox Flex',
      'SparBox Fix kann nicht ohne SparBox Flex - Konto eröffnet werden. Aus diesem Grund eröffnen Sie bitte die SparBox Fix & Flex.',
      '',
      'alreadyExists'
    )
  }

  openMissingRequiredProductErrorForFixExclusive() {
    this.modalwithbuttons(
      'Sie haben keine BAWAG SparBox Flex',
      'SparBox Fix Exklusiv kann nicht ohne SparBox Flex-Konto eröffnet werden. Aus diesem Grund eröffnen Sie bitte zuerst SparBox Flex und dann SparBox Fix Exklusiv.',
      '',
      'alreadyExists'
    )
  }

  openLimitExceedApplicationError() {
    this.modalwithbuttons(
      'Sie sind bereits BAWAG Kunde',
      'Die maximale Anzahl an B4-19 SparBox Flex Konten wurde für diesen Kunden erreicht. Bitte fahren Sie mit einem anderen Produkt fort.',
      '',
      'alreadyExists'

    )

  }

  openLimitExceedOtherApplicationError() {
    this.modalwithbuttons(
      'Sie sind bereits BAWAG Kunde',
      'Die maximale Anzahl an SparBox Fix Konten wurde für diesen Kunden erreicht. Bitte fahren Sie mit einem anderen Produkt fort.',
      '',
      'alreadyExists'

    )

  }

  openNonRetailUserApplicationError() {
    this.modalwithbuttons(
      'Kundensegment',
      'Für dieses Kundensegment sind keine Produkte verfügbar.',
      '',
      'alreadyExists'

    )

  }

  openNoProductChange() {
    this.modalwithbuttons(
      'Produktwechsel',
      'Ihr Kunde besitzt kein Produkt, das für einen Produktwechsel geeignet ist.',
      '',
      'alreadyExists'

    )

  }


    openTechnicalError() {
    this.modalwithbuttons(
      'Technischer Fehler',
      'Leider ist ein technischer Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
      '',
      'logout',
    );
  }


  openAgeCheckFailed() {
    this.modalwithAgeCheckbuttons(
      'Unser Kontomodell für Ihre Bedürfnisse ',
      'Es scheint, dass Ihr Alter die Berechtigungs- grenze für diesen Kontotyp überschreitet. ',
      'Um sicherzustellen, dass Sie die beste Erfahrung machen, empfehlen wir Ihnen, ein auf Ihre Bedürfnisse zugeschnittenes Konto zu eröffnen.',
      'ageMismatchError'
    )
  }

  openApplicationExistsError() {
    this.modalwithbuttons(
      'Kontoantrag bereits vorhanden',
      'Sie haben bereits einen Kontoantrag begonnen.',
      'Um den Antrag fortzusetzen, verwenden Sie bitte den Link in der zum Antrag gehörigen E-Mail.',
      'applicationExists'
    );
  }

openApplicationOldFlowError(){
  this.modalwithbuttons(
    'Ihr vereinfachter Weg zur Kontoeröffnung',
    'Wir haben es Ihnen noch einfacher gemacht, ein Konto online zu eröffnen.',
    'Unser neuer, vereinfachter Prozess ist auf Sie zugeschnitten. Bitte starten Sie einen neuen Antrag und genießen Sie das optimierte Erlebnis!',
    'ageMismatchError'
  );
}


  openEmailExistsError() {
    this.open('Eingabe fehlerhaft', 'Bitte verwenden Sie eine andere E-Mail-Adresse.');
  }

  openCaptchaRequiredError() {
    this.open('Fehler', ' Bitte warten Sie ein paar Minuten und versuchen Sie es erneut.');
  }


  openFileUploadError() {
    this.open(
      'Fehler aufgetreten',
      'Hochladen nicht möglich. Bitte verwenden Sie PDF, PNG, JPG oder JPEG Dateien. Maximale Größe: 20MB.'
    );
  }

  openProductCreationError() {
      this.modalwithbuttons(
        'Antrag muss in der Zentrale nachbearbeitet werden',
        'Leider ist ein Fehler innerhalb des Antrages aufgetreten.',
        'Es wurde eine Nachricht mit Bitte um Bearbeitung des Antrags an die zuständige Stelle gesendet.',
        'redirect'
      );
  }

  openLogout() {
    this.modalwithbuttons(
      'Möchten Sie sich wirklich ausloggen?',
      'Wenn Sie sich ausloggen, gehen alle bisher eingegebenen Daten verloren.',
      '',
      'logout'
    );
  }

  // openLegiNotDone() {
  //   this.open(
  //     'Kein aktueller Ausweis hinterlegt',
  //     'Bevor Sie diesen Kontoantrag fortsetzen, muss ein aktuelles Ausweisdokument des Kunden hinterlegt werden.'
  //   );
  // }


  openFatcaError() {
    this.open('Fehler aufgetreten', ' Im Moment können wir Sie online nicht registrieren, bitte wenden Sie sich an die nächste BAWAG Filiale.');
  }

  openLegiNotDone(){
    this.openPopUp(
      'Kein aktueller Ausweis',
      'Hinterlegen sie ein aktuelles Ausweisdokument des Kunden, um diesen Kontoantrag fortzusetzen.',
      'Starten Sie die digitale Legitimierung. Falls diese fehlschlägt, können Sie mit erneutem Klick auf „Ausweis hinterlegt“ mit der manuellen Legitimierung des Kunden fortfahren.'

    )
  }

  openManualLegiNotDone() {
    this.modalwithManualLegibuttons(
      'Kein aktueller Ausweis hinterlegt',
      'Es wurde noch kein aktueller Ausweis hinterlegt.',
      "Falls die digitale Legitimierung nicht funktioniert hat, können Sie nun den Kunden manuell legitimieren.",
      "Erneut digital versuchen",
      '',
      'later'
    );
  }

  openAgeMismatchError() {
    this.modalwithbuttons(
      'Unsere Kontomodelle für Ihre Bedürfnisse',
      'Wir bieten Ihnen gerne Kontomodelle, die vollkommen auf Ihre Bedürfnisse zugeschnitten sind.',
      'Leider erfüllen Sie derzeit nicht die benötigten Voraussetzungen für Ihr Wunschprodukt.',
      'ageMismatchError'
    );
  }

  openStudentAgeMismatchError() {
    this.modalwithbuttons(
      'Unsere Kontomodelle für Ihre Bedürfnisse',
      'Sie haben die Studenten KontoBox ausgewählt, die eine Altersgrenze von 18-27 Jahren hat. ',
      'Bitte beachten Sie die anderen Produkte.',
      'ageMismatchError'
    );
  }




  openNotATAddressError() {
    this.modalwithbuttons(
      'Kundenadresse nicht in Österreich',
      'Die Wohnsitzadresse des Kunden befindet sich nicht in Österreich. Dieser Fall wird zur Zeit noch nicht von der Antragsstrecke unterstützt.',
      'Bitte eröffnen Sie das Konto wie gewohnt in Gate oder Alfa.',
      'addressCheckError'
    );
  }

  openPhoneNumberError() {
    this.modalwithbuttons(
      'Telefonnummer ungültig',
      'Bitte aktualisieren Sie Ihre hinterlegte Mobiltelefonnummer  bevor Sie den Antrag beginnen.',
      '',
      'phoneNumberNotFound'
    );
  }

  openBadRequestError() {
    this.open('Eingabe fehlerhaft', 'Bitte überprüfen Sie die Eingabefelder.');
  }

  openBlockEmployeeError() {
    this.open('Achtung!', ' Bitte wenden Sie sich an die Mitarbeiterbetreuung.');
  }

  openBadIbanInvalidRequestError() {
    this.open('Eingabe fehlerhaft', 'Der Name des IBAN-Inhabers stimmt nicht mit dem Namen im Antrag überein.');
  }

    getPopupEvent(): Observable<any> {
    return this.passEvent$.asObservable();
  }

  
    clearPopupEvent() {
    this.passEvent$.next(null);
  }

   setPopupEvent(fireEventFrom: string) {
    this.passEvent$.next(fireEventFrom);
  }

  // feedbackModal() {
  //   this.ngbModal.open(FeedbackModalComponent, this.ngbFbModalOptions);
  // }
}
